import $ from 'jquery'

export class TimelineContent {

  constructor($container) {
    this.$window = $(window)
    this.$timeline = $container
    this.$dashedHideSvg = this.$timeline.find('.timeline-dashed-hide-svg')

    this.$window.on('load', this.handleOnLoad.bind(this))
  }

  handleOnLoad() {
    this.$dashedHideSvg.css('stroke-dasharray', this.$dashedHideSvg.height() + 'px')

    this.whenCallAnimate()

    this.$window.scroll(this.whenCallAnimate.bind(this))
  }

  whenCallAnimate() {
    let timelineOffset = this.$timeline.offset()
    let diff = (this.$window.scrollTop() + (this.$window.height() - (this.$window.height() / 2.5))) - (timelineOffset.top)

    if ((this.$window.scrollTop() + (this.$window.height() - (this.$window.height() / 2.5))) >= (timelineOffset.top)) {
      this.aboutPathAnimate(diff, this.$timeline)
    }
  }

  aboutPathAnimate(diff) {
    this.$dashedHideSvg.css('stroke-dashoffset', '-' + (diff))
  }
}
